import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

// Create axios instance with auth
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const pollsApi = {
  /**
   * CREATE POLL
   * Endpoint: POST /api/posts/polls
   * Body: { poll, content }
   */
  createPoll: async (pollData) => {
    return apiClient.post("/posts/polls", pollData);
  },

  /**
   * VOTE ON POLL
   * Endpoint: POST /api/posts/:id/vote-poll
   * Body: { options } - Array of option indices
   */
  votePoll: async (postId, options) => {
    return apiClient.post(`/posts/${postId}/vote-poll`, { options });
  },

  /**
   * GET POLL RESULTS
   * Endpoint: GET /api/posts/:id/poll-results
   */
  getPollResults: async (postId) => {
    return apiClient.get(`/posts/${postId}/poll-results`);
  },
};

export default pollsApi;
